module.exports = __webpack_public_path__ + "img/Vector-Welcome.de0abcfa.png";